export const THEMES_IMAGES = {
  BTN_ARROW_ICON_WHITE: 'button_arrow_icon_white.svg',
  BTN_ARROW_ICON_GREEN: 'button_arrow_icon_green.svg',
  BTN_ARROW_ICON_BLUE: 'button_arrow_icon_blue.svg'
};
